import { LOCATION_CHANGE } from 'redux-first-history';
import { HOME } from '../common/routes';

let previousUrl = HOME;

export default () => {
  return (next) => (action) => {
    if (action.type === LOCATION_CHANGE) {
      const { location } = action.payload;
      action.payload.location = { ...location, previousUrl };

      const { pathname, search } = location;
      // TODO: keep #hash
      previousUrl = `${pathname}${search}`;
    }
    return next(action);
  };
};
